import React from 'react'
import Landing from '../routes/landings/Patio'

const Patio = () => {
  return <Landing />
}

export default Patio
